import { createTheme } from "@mui/material/styles";

// Light theme configuration
export const lightTheme = createTheme({
    typography: {
        fontFamily: "'Inter', sans-serif",
        h1: { fontWeight: 700 },
        h2: { fontWeight: 700 },
        h3: { fontWeight: 600 },
        h4: { fontWeight: 600 },
        h5: { fontWeight: 600 },
        h6: { fontWeight: 600 },
    },
    palette: {
        mode: 'light',
        background: {
            default: '#FFFFFF',
            paper: '#FFFFFF',
        },
        primary: {
            main: '#000000',
            light: '#333333',
            dark: '#000000',
            contrastText: '#FFFFFF',
        },
        secondary: {
            main: '#464887',
            light: '#6B6FA3',
            dark: '#2E3159',
        },
        text: {
            primary: '#000000',
            secondary: '#6B7280',
        },
        divider: '#000000',
        dividerSecondary: '#E5E7EB',
        action: {
            hover: 'rgba(0, 0, 0, 0.04)',
            selected: 'rgba(0, 0, 0, 0.08)',
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    borderRadius: 8,
                },
            },
        },
        MuiToggleButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                },
            },
        },
    },
});

// Dark theme configuration
export const darkTheme = createTheme({
    typography: {
        fontFamily: "'Inter', sans-serif",
        h1: { fontWeight: 700 },
        h2: { fontWeight: 700 },
        h3: { fontWeight: 600 },
        h4: { fontWeight: 600 },
        h5: { fontWeight: 600 },
        h6: { fontWeight: 600 },
    },
    palette: {
        mode: 'dark',
        background: {
            default: '#282828',
            paper: '#2B2B2BED',
        },
        primary: {
            main: '#FFFFFF',
            light: '#F9FAFB',
            dark: '#E5E7EB',
            contrastText: '#000000',
        },
        secondary: {
            main: '#282828',
            light: '#5A5A5A',
            dark: '#000000',
        },
        text: {
            primary: '#F9FAFB',
            secondary: '#94A3B8',
        },
        divider: '#FFFFFF',
        dividerSecondary: '#E5E7EB',

        action: {
            hover: 'rgba(255, 255, 255, 0.08)',
            selected: 'rgba(255, 255, 255, 0.16)',
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    borderRadius: 8,
                },
            },
        },
        MuiToggleButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                },
            },
        },
    },
});

export default lightTheme;
